var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dropper',{attrs:{"index":_vm.index,"level":2}}),(_vm.$parent.editMode)?_c('div',{staticClass:"delete is-pulled-right",on:{"click":_vm.remove}}):_vm._e(),_c('div',{staticClass:"top10 bottom10",class:{bottom30: !_vm.$parent.editMode},staticStyle:{"border-bottom":"2px dotted #f1c232"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }